import * as React from "react";

export function DropdownChevronIcon({ style, ...props }: any): JSX.Element {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
      style={{ ...style, top: "calc(50% - 2.5px)", right: "8px" }}
    >
      <path
        d="M0.75 0.75L4.08333 4.08333L7.41667 0.75"
        stroke="#2E3860"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
